<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "spot",
        key: "spot_id",
        url: {},
        output: false,
      },
      menus: [
        {
          label: "景点列表",
          name: "spot_list",
          auth: "/admin/spot/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/spot/add",
        },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {},
      currentRow: null,
      filters: [{ label: "景点名称", name: "title", value: "", type: "input" }],
      tableCols: [
        {
          title: "ID",
          key: "spot_id",
          width: 80,
          align: "center",
        },

        {
          title: "景点名称",
          minWidth: 120,
          key: "title",
        },
        {
          title: "图片",
          key: "image",
          minWidth: 120,
          align: "center",
          viewimage: true,
        },
        {
          title: "类型",
          key: "type_name",
          minWidth: 100,
          align: "center",
        },
        {
          title: "景点简介",
          minWidth: 120,
          key: "content",
          render: (h, params) => {
            const row = params.row;
            const text = row.content;
            return (
              <div
                style={{
                  minWidth: "120px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                }}
              >
                {text}
              </div>
            );
          },
        },
        {
          title: "语音介绍",
          minWidth: 120,
          key: "audio",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.audio) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      size: "small",
                      type: "success",
                    },
                    style: {
                      margin: "0 5px",
                    },
                    // 自定义指令

                    on: {
                      click: () => {
                        let url = $utils.video.load(row.audio);
                        this.$set(this.pass2, "model2", true);
                        this.$set(this.pass2, "kv", url);
                        this.$set(this.pass2, "content", "语音介绍");
                      },
                    },
                  },
                  "播放"
                ),
              ]);
            }
          },
        },
        {
          title: "经纬度",
          minWidth: 140,
          key: "lnglat",
        },
        {
          title: "地址",
          minWidth: 170,
          align: "center",
          key: "address",
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          switch: true,
          disabled: false,
        },
        {
          title: "排序",
          align: "center",
          sortable: "custom",
          key: "sort",
          width: 90,
          editable: true,
        },
        {
          title: "更新时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              let directives = [{ name: "auth", value: "/admin/spot/edit" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.editBtn(currentRow)}
                  type="primary"
                  style={{ margin: "4px 5px" }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            del: "/admin/spot/del",
          },
        },
      ],
    };
  },
  created() {},

  methods: {
    toAdd() {
      $utils.url.push({ name: "spot_add", query: { action: "add" } });
    },
    editBtn(currentRow) {
      $utils.url.push({
        name: "spot_edit",
        query: { action: "edit", kv: currentRow.spot_id },
      });
    },
  },
};
</script>
